var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sb-paytable-stroke-title"},[_c('div',{staticClass:"sb-paytable-stroke-title-img"},[_c('img',{attrs:{"src":_vm.title,"alt":""}})]),_c('div',{staticClass:"sb-paytable-title-stroke",staticStyle:{"background-image":"url('./assets/common/paytable/title_stroke.png')"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }